(() => {
  if (window.platformNavigationReady) return;
  window.platformNavigationReady = true;
  const hover = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  const findMenus = () => [...document.querySelectorAll('details[data-platform-nav]')];
  const initialise = () => {
    findMenus().forEach(details => {
      if (details.dataset.navReady) return;
      details.dataset.navReady = 'true';
      const summary = details.querySelector('summary');
      const hoverTarget = details.closest('.platform-nav__item') || details;
      let leaveTimer;
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) {
          const list = details.closest('.m-menu, .m-menu-mobile');
          list?.querySelectorAll('details[data-platform-nav]').forEach(other => {
            if (other !== details) other.open = false;
          });
        }
      });
      hoverTarget.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimer);
        if (hover.matches) details.open = true;
      });
      hoverTarget.addEventListener('mouseleave', () => {
        if (hover.matches) {
          leaveTimer = setTimeout(() => {
            if (!details.contains(document.activeElement)) details.open = false;
          }, 180);
        }
      });
      details.addEventListener('focusout', event => {
        if (window.innerWidth >= 1024 && !details.contains(event.relatedTarget)) details.open = false;
      });
    });
  };
  document.addEventListener('click', event => {
    findMenus().forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focusedMenu = document.activeElement?.closest('details[data-platform-nav]');
    const opened = findMenus().filter(details => details.open);
    opened.forEach(details => { details.open = false; });
    if (window.innerWidth >= 1024 && opened.length) {
      event.preventDefault();
      (focusedMenu || opened[0]).querySelector('summary')?.focus();
    }
  });
  window.addEventListener('resize', () => findMenus().forEach(details => { details.open = false; }));
  document.addEventListener('shopify:section:load', initialise);
  initialise();
})();
